import { memo, useState } from "react"
import Chips from "../../../../../../library/Chips/Chips"
const PaiGowGameControllers = memo((props) => {
    return <>
        <div className="paiGowChipsBox">
            <div className="chipArrowsBox" onClick={() => {
                if (props.selectedChip >= 1) {
                    props?.playChipSound();
                    props.setChipCount((prevState) => prevState - 1);
                }
            }}>
                <button className="chipArrows" disabled={props.selectedChip === 0 || props.isIncDecChips}>
                </button>
            </div>
            <div className="chipsBox">
                <div className="allChips" style={{ "--selectedIndex": props.selectedChip }}>
                    <Chips
                        selectedChipIndex={props.selectedChip}
                        chipSelectionFn={(_, index) => {
                            window.innerHeight > window.innerWidth && props?.playChipSound();
                            !props.isIncDecChips && props.setChipCount(index);
                        }}
                        gameChips={props.chipsArray}
                        chipWidth="100%"
                        chipHeight="100%"
                    />

                </div>
            </div>
            <div className="chipArrowsBox" onClick={() => {
                if (props.selectedChip < props.chipsArray.split(",").length - 1) {
                    props?.playChipSound();
                    props.setChipCount((prevState) => prevState + 1);
                }
            }}
            >
                <button className="chipArrows rightArrow" disabled={props.selectedChip === props.chipsArray.split(",").length - 1 || props.isIncDecChips}>
                </button>
            </div>
        </div>
    </>
})

export default PaiGowGameControllers